import api from '@/api'

export default {
  async getTeams(context, { organizationId, filters, options }) {
    const payload = options ?? {}
    if (filters) {
      payload.filters = filters
    }
    const response = await api.teams.getTeams(organizationId, payload)
    return response.data
  },

  async getTeamsCatalog(context, { organizationId, filters, options }) {
    const payload = options ?? {}
    if (filters) {
      payload.filters = filters
    }
    const response = await api.teams.getTeamsCatalog(organizationId, payload)
    return response.data
  },

  async createTeam(context, { organizationId, teamData }) {
    const response = await api.teams.create(organizationId, teamData)
    return response.data
  },

  async updateTeam(context, { organizationId, teamId, teamData }) {
    return await api.teams.update(organizationId, teamId, teamData)
  },

  async deleteTeam(context, { organizationId, teamId }) {
    return await api.teams.delete(organizationId, teamId)
  },

  async updateMembers(context, { organizationId, teamId, members }) {
    return await api.teams.updateMembers(organizationId, teamId, members)
  },

  async getSiteAccounts(context, { organizationId, siteId, terms }) {
    const options = {
      filters: { isDeleted: false, site: siteId },
    }

    options.limit = 50

    if (terms) {
      options.terms = terms
    }

    return api.account.getAccounts(organizationId, options).then(response => {
      return response.data.results
    })
  },
}
